import {Merchant} from "../../client/state/MerchantStore";
import {BlinkGlobal} from "../UtilsLib";
import type {StoreId} from "../../stem-core/state/State";


// TODO @flow this file should be dismantled
class IframeMerchantService {
    // Set by init(), from the iframe params
    declare merchantId?: StoreId;
    init(merchantId: StoreId) {
        this.merchantId = merchantId;
        BlinkGlobal.iFrameMerchantService = this;
    }

    getMerchant() {
        return Merchant.get(this.merchantId);
    }

    // For hardcoded stuff.
    isMerchant(alias: string) {
        return this.getMerchant()?.alias === alias;
    }
}

export const iFrameMerchantService = new IframeMerchantService();
